import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 pt-2" }
const _hoisted_2 = { class: "fw-bold body-strong" }
const _hoisted_3 = { class: "d-flex flex-column gap-3" }

import { computed, ref } from 'vue';
import greenSnowFlake from '@/images/green-snowflake.png';
import greenKey from '@/images/green-key.png';
import greenKeyFR from '@/images/green-key-fr.png';

// Enums
import { Locales } from '@/enums/locales';

// Components
import RSEcard from './RSEcard.vue';

// Composables
import useLocale from '@/vue/composables/useLocale';

interface IRSEblock {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'RSEblock',
  props: {
    isCriteriaFloconVert: { type: Boolean },
    isCriteriaCleVerte: { type: Boolean }
  },
  setup(__props: any) {

const locale = ref<string>(useLocale());

// Props
const props = __props;

// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Computed values
const greenKeyLogo = computed<string>(() => {
  const localeMap: Record<string, string> = {
    [Locales.FR]: greenKeyFR,
    [Locales.UK]: greenKey,
    [Locales.NL]: greenKey,
  };
  return localeMap[locale.value] || greenKeyFR;
});

// Compute the eco-responsible commitment labels title based on the criteria
const Title = computed<string>(() => {
  if (props.isCriteriaFloconVert && props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_both;
  } else if (props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_cleverte;
  } else if (props.isCriteriaFloconVert) {
    return content.value.eco_responsible_commitment_labels_title_if_flaconvert;
  }
  return '';
});


// Data for cards
const greenSnowFlakePopupData = {
  title: content.value.eco_responsible_commitments_green_snowflake_label,
  description: content.value.eco_responsible_commitments_green_snowflake_text,
  icon: greenSnowFlake,
};

const greenKeyPopupData = {
  title: content.value.eco_responsible_commitments_green_key_label,
  description: content.value.eco_responsible_commitments_green_key_text,
  icon: greenKeyLogo.value,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(Title.value), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isCriteriaFloconVert)
        ? (_openBlock(), _createBlock(RSEcard, {
            key: 0,
            title: greenSnowFlakePopupData.title,
            description: greenSnowFlakePopupData.description,
            icon: greenSnowFlakePopupData.icon,
            linkKey: "green-snowflake"
          }, null, 8, ["title", "description", "icon"]))
        : _createCommentVNode("", true),
      (_ctx.isCriteriaCleVerte)
        ? (_openBlock(), _createBlock(RSEcard, {
            key: 1,
            title: greenKeyPopupData.title,
            description: greenKeyPopupData.description,
            icon: greenKeyPopupData.icon,
            linkKey: "green-key"
          }, null, 8, ["title", "description", "icon"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})